import React from 'react';
import { Trans } from 'react-i18next';

import SummaryBanner from '../../../components/Base/Banner/SummaryBanner';
import ErrorDisplay from '../ErrorDisplay';

const SummaryError = ({ translationKeyTitle, isBannerOpenSession = false }) => (
  <>
    <SummaryBanner openSession={isBannerOpenSession} />
    <ErrorDisplay errorTitle={<Trans>{translationKeyTitle}</Trans>} />
  </>
);

export default SummaryError;
